function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "12",
  viewBox: "0 0 15 12",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.195 14.056l3.459-3.458c.376-.376.376-.978 0-1.316-.376-.376-.977-.376-1.316 0l-5.075 5.037a.968.968 0 00-.263.677c0 .226.075.489.263.677l5.038 5.038c.376.376.977.376 1.316 0 .375-.376.375-.977 0-1.316l-3.459-3.458h10.978c.488 0 .864-.414.864-.94 0-.527-.338-.94-.827-.94H11.196z",
  id: "path-arrow-forward"
})), /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  transform: "rotate(180 11.5 10.496)",
  xlinkHref: "#path-arrow-forward",
  fillRule: "evenodd"
})));